import React, { forwardRef, useState } from 'react';
import Modal, { ModalRef } from 'components/Modal/Modal';
import TabPanel, { TabPanelItems } from 'components/TabPanel/TabPanel';
import TenantInvoices from './TenantInvoices';
import { TenantSummary } from './utils';
import styles from './Tenants.module.css';

type TenantModalProps = {
    tenant: TenantSummary | null;
    month: string;
    timeZone?: string;
    launchDate?: string;
    onClose: () => void;
};

enum TenantModalTab {
    Invoices = 'invoices',
}

const TenantModal = forwardRef<ModalRef, TenantModalProps>(({ tenant, month, timeZone, launchDate, onClose }, ref) => {
    const [activeTab, setActiveTab] = useState(TenantModalTab.Invoices);

    const tabs: TabPanelItems<TenantModalTab> = tenant
        ? [
              {
                  title: 'Invoices',
                  key: TenantModalTab.Invoices,
                  component: (
                      <TenantInvoices
                          tenant={tenant}
                          initialMonth={month}
                          timeZone={timeZone}
                          launchDate={launchDate}
                      />
                  ),
              },
          ]
        : [];

    return (
        <Modal ref={ref} title={tenant?.name} onClose={onClose}>
            {tenant && (
                <div className={styles.modalBody}>
                    <TabPanel items={tabs} activeTabKey={activeTab} setActiveTab={setActiveTab} />
                </div>
            )}
        </Modal>
    );
});

export default TenantModal;
